import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { wacToken } from '@/libraries/design/foundations';

/**
 * WARNING:
 * Before your make any changes to the Rovo Dev terms and conditions,
 * validate the changes with the Rovo Dev Enablement team (Jolt - #help-jolt).
 *
 * For more context, see:
 * https://hello.atlassian.net/wiki/spaces/AIDO/pages/6079320096/Rovo+Dev+Standard+sign+up+flows
 */
export const PrivacyPolicy = () => (
	<div css={privacyPolicyCss}>
		<p>
			<b>
				<FormattedMessage
					id="signup-page.rovo-dev-privacy-policy.title"
					defaultMessage="Rovo Dev Standard - 30-day trial, then $20 USD per user per month"
				/>
			</b>
		</p>
		<p>
			<FormattedMessage
				id="signup-page.rovo-dev-privacy-policy.agreement-terms"
				// TODO: https://softwareteams.atlassian.net/browse/JOLT-2177
				// defaultMessage="By selecting <b>Agree and start now</b>, you agree to the <customerAgreementLink>Atlassian Customer Agreement</customerAgreementLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. At the end of your trial, billing begins and renews automatically. Cancel anytime."
				defaultMessage="By selecting <b>Agree and start now</b>, you agree to the <customerAgreementLink>Atlassian Customer Agreement</customerAgreementLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. At the end of your trial, billing begins and renews automatically."
				values={{
					customerAgreementLink: (chunks) => (
						<a css={linkCss} href="https://www.atlassian.com/legal/atlassian-customer-agreement">
							{chunks}
						</a>
					),
					privacyPolicyLink: (chunks) => (
						<a css={linkCss} href="https://www.atlassian.com/legal/privacy-policy">
							{chunks}
						</a>
					),
					b: (chunks) => <b>{chunks}</b>,
				}}
			/>
		</p>
		<p>
			<FormattedMessage
				id="signup-page.rovo-dev-privacy-policy.mcp-information"
				defaultMessage="Rovo Dev CLI and Rovo Dev in IDE may not be available while on free trial. Rovo Dev allows users to connect and send data to Third-Party Products and data sources through model context protocol (MCP). <mcpLink>Read about MCP and your responsibilities</mcpLink>"
				values={{
					mcpLink: (chunks) => (
						<a
							css={linkCss}
							href="https://support.atlassian.com/rovo/docs/rovo-dev-and-model-context-protocol-mcp/"
						>
							{chunks}
						</a>
					),
				}}
			/>
		</p>
	</div>
);

const privacyPolicyCss = css({
	fontSize: 13,
});

const linkCss = css({
	color: wacToken('color.primary.blue'),
	textDecoration: 'underline',
	[':hover']: {
		textDecoration: 'none',
	},
});
